import mainTranslate from 'loankeeper-common/helpers/language'
import { formName } from './constants'

export const translate = (key: string): string => mainTranslate(formName, key)
export const translateWebMessages = (key: string): string => translate(`frm_web_messages-${key}`)
